import React, { useState } from 'react'
import { navigateWithBasepath as navigate } from '../../App'
import { SearchDropdown, HighlightedText } from '@ui'
import { IReport } from './types'
import fuzzy from 'fuzzaldrin-plus'
import track from '@track'

interface IProps {
  reports: IReport[]
}

export default function ReportsSearch({ reports }: IProps) {
  const onSelect = (r: IReport) => {
    track.reportCatalog({
      eventName: track.Event.SEARCH_RESULT_CLICK,
    })
    navigate(`/reports/${encodeURIComponent(r.categoryName)}/${r.id}`, {})
  }
  const [query, setQuery] = useState<string>('')
  const filteredList = fuzzy
    .filter(
      reports.filter(({ id }) => !id.includes('Single')),
      query,
      {
        key: 'name',
      }
    )
    .slice(0, 7)

  const search = {
    query,
    items: query ? filteredList : [],
    run: (s: string) => setQuery(s),
  }

  return (
    <SearchDropdown
      search={search}
      width="400px"
      onSelect={onSelect}
      renderItem={(r: IReport) => <Report report={r} query={query} />}
    />
  )
}

const Report = ({ report, query }: { report: IReport; query: string }) => (
  <div>
    <HighlightedText text={report.name} query={query} />
    <div style={{ color: '#6A6869', fontSize: 10 }}>{report.categoryName}</div>
  </div>
)
